export enum ChannelGroupsEnum {
  SERVICE = 'service',
  MARKETING = 'marketing',
}

export enum ChannelNamesEnum {
  SMS = 'sms',
  CALL = 'call',
  PUSH = 'push',
  EMAIL = 'email',
}

export interface IChannelGroup {
  name: ChannelGroupsEnum;
  isEnabled: boolean;
  initial: boolean;
}

export interface IChannel {
  name: ChannelNamesEnum;
  groups: Record<ChannelGroupsEnum, IChannelGroup>;
}
